

export class ResetPassword {
	email: String;
	hashPassword: String;
}